export const sanitizeColumnId = (id: string) =>
  id.toLowerCase().replace(/\s+/g, '-')

// Reconciles a persisted column order against the table's live leaf columns:
export const reconcileColumnOrder = (
  savedOrder: string[],
  leafIds: string[],
): string[] => {
  const kept = savedOrder.filter(id => leafIds.includes(id))
  return [...kept, ...leafIds.filter(id => !kept.includes(id))]
}

// Moves draggedId to targetId's position within currentOrder. Returns the new
// order, or null when the move is a no-op (either id missing, or same position).
export const reorderColumns = (
  currentOrder: string[],
  draggedId: string,
  targetId: string,
): string[] | null => {
  const from = currentOrder.indexOf(draggedId)
  const to = currentOrder.indexOf(targetId)
  if (from === -1 || to === -1 || from === to) return null

  const next = [...currentOrder]
  next.splice(from, 1)
  next.splice(to, 0, draggedId)
  return next
}
